<template>
  <div>
    <div v-if="loader" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner> -->
      <idx-skeleton-chart type="area" class="mt-4" />
    </div>
    <div v-else-if="chartOptions && !loader">
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import idxSkeletonChart from '@/components/molecules/idx-skeleton-chart';
import eventBus from '../../../../../../eventBus';
import api from '../../../../../../services/api';

export default {
  name: 'InviteEvolutionPanels',
  props: ['dataGraph', 'reportType', 'accumulated'],

  components: {
    idxSkeletonChart,
  },

  data: () => ({
    chartOptions: null,
    loader: true,
    legend: '',
    monthly: false,
    checked: true,
    data: null,
  }),
  watch: {
    dataGraph: {
      handler: async function () {
        await this.prepareChart();
      },
      deep: true,
    },
    accumulated: async function watchAccumulated() {
      await this.prepareChart();
    },
  },

  methods: {
    ...mapActions('charts', [
      'evolutionDailyInvites',
      'evolutionPeriodInvites',
    ]),
    ...mapActions('calendar', ['setDefaultDates']),

    prepareChart() {
      const type = this.reportType ? this.reportType : 'month';

      switch (type) {
        case 'day':
          this.setColumns();
          break;
        case 'week':
          this.setColumnsPeriod();
          break;
        case 'month':
          this.setColumnsPeriod();
          break;
        case 'quarter':
          this.setColumnsPeriod();
          break;
        default:
          break;
      }
    },
    async setColumns() {
      this.loader = true;

      const response = await api.get(`reports/invites-evolution-panel/daily`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          // startDate: '2022-01-15',
          // endDate: '2022-07-21',
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          metric: this.dataGraph.metric,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          reportType: this.reportType,
          period: this.dataGraph.period,
          _id: this.dataGraph._id,
        },
      });

      if (this.accumulated) {
        this.renderChart({
          categories: response.data.categories,
          series: response.data.seriesAccumulated,
        });
      } else {
        this.renderChart({
          categories: response.data.categories,
          series: response.data.series,
        });
      }

      this.data = response.data;

      if (this.accumulated) {
        this.chartOptions.series.push({
          name: '%Conversão',
          dataLabels: {
            enabled: true,
            format: '{y:.2f}%',
          },
          type: 'spline',
          data: this.data.answeredAccumulated,
          color: '#17a2b8',
        });
      } else {
        this.chartOptions.series.push({
          name: '%Conversão',
          dataLabels: {
            enabled: true,
            format: '{y:.2f}%',
          },
          type: 'spline',
          data: this.data.answered,
          color: '#17a2b8',
        });
      }

      this.loader = false;
    },

    async setColumnsPeriod() {
      this.loader = true;


      const response = await api.get(`reports/invites-evolution-panel/period`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          actionId: this.dataGraph.actionId
            ? this.dataGraph.actionId._id
            : null,
          // startDate: '2022-01-15',
          // endDate: '2022-07-21',
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          groupId: this.dataGraph.actionGroupId
            ? this.dataGraph.actionGroupId._id
            : null,
          metric: this.dataGraph.metric,
          indicator: this.dataGraph.indicator ? this.dataGraph.indicator : null,
          indicatorValue: this.dataGraph.valueIndicator,
          period: this.dataGraph.period,
          reportType: this.reportType,
          _id: this.dataGraph._id,
        },
      });

      if (this.accumulated) {
        this.renderChart({
          categories: response.data.categories,
          series: response.data.seriesAccumulated,
        });
      } else {
        this.renderChart({
          categories: response.data.categories,
          series: response.data.series,
        });
      }

      this.data = response.data;

      if (this.accumulated) {
        this.chartOptions.series.push({
          name: '%Conversão',
          dataLabels: {
            enabled: true,
            format: '{y:.2f}%',
          },
          type: 'spline',
          data: this.data.answeredAccumulated,
          color: '#17a2b8',
        });
      } else {
        this.chartOptions.series.push({
          name: '%Conversão',
          dataLabels: {
            enabled: true,
            format: '{y:.2f}%',
          },
          type: 'spline',
          data: this.data.answered,
          color: '#17a2b8',
        });
      }

      this.loader = false;
    },

    async renderChart(data) {
      if (data.series.length > 0) {
        const max = data.series.reduce((a, b) => Math.max(a, b));

        this.chartOptions = {
          title: {
            text: '',
            style: {
              color: '#5f6368',
            },
          },
          chart: {
            type: this.dataGraph.graph,
            borderColor: 'rgba(0, 0, 0, 0.09)',
            style: {
              fontFamily:
                '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              fontSize: '12px',
              width: '100%',
            },
          },
          xAxis: {
            categories: data.categories,
            visible: true,
            labels: {},
          },
          yAxis: [
            {
              // Primary yAxis
            },
            {
              // Secondary yAxis
              max,
              min: 0,
              gridLineWidth: 0,
              labels: {
                enabled: false,
              },
              title: {
                text: '',
              },
              stackLabels: {
                enabled: true,
                fontWeight: 'bold',
              },
            },
          ],
          series: [
            {
              name: this.$t('reports.inviteLabel'),
              data: data.series,
            },
          ],
          legend: {
            enabled: true,
          },
          plotOptions: {
            column: {
              pointPadding: 0.1,
              borderWidth: 0,
              yAxis: 1,
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            line: {
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              yAxis: 1,
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            area: {
              dataLabels: {
                enabled: true,
                format: '{y:.0f}',
              },
              yAxis: 1,
              tooltip: {
                pointFormat: '<span>{series.name}<b> {point.y:.0f}<b/> <br/>',
                shared: true,
              },
              showInLegend: true,
            },
            series: {
              groupPadding: 0,
              pointPadding: 0.05,
              borderWidth: 0,
            },
          },
          colors: ['#4ce595'],
        };

        this.chartOptions.yAxis[0] = {
          title: {
            text: '',
            style: {
              color: 'blue',
            },
          },
        };
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  async mounted() {
    this.loader = true;

    

    this.prepareChart();

    eventBus.$on('accumulated-report', (checked) => {
      this.accumulated = checked;
      switch (this.accumulated) {
        case true:
          this.renderChart({
            categories: this.invitesEvolution.categories,
            series: this.invitesEvolution.seriesAccumulated,
          });
          break;
        case false:
          this.renderChart({
            categories: this.invitesEvolution.categories,
            series: this.invitesEvolution.series,
          });
          break;
        default:
          this.legend = ' ';
      }
    });
    eventBus.$on('data-source', () => {
      this.prepareChart();
    });

    eventBus.$on('switch-chart', (chart) => {
      this.type = chart;
      this.loader = true;
      if (this.accumulated) {
        this.renderChart({
          categories: this.invitesEvolution.categories,
          series: this.invitesEvolution.seriesAccumulated,
        });
      } else {
        this.renderChart({
          categories: this.invitesEvolution.categories,
          series: this.invitesEvolution.series,
        });
      }

      this.loader = false;
    });

    // this.loader = false;
  },
  beforeDestroy() {
    eventBus.$off('switch-chart');
    eventBus.$off('data-source');
    eventBus.$off('accumulated-report');
  },
};
</script>

<style lang="scss" scoped>
.right-switch {
  text-align: right;
  margin-top: 10px;
  position: absolute;
  z-index: 999;
  right: 40px;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/treatments-tags/panels/invites-evolution.vue